import type { ReactNode } from 'react';

import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XIcon } from 'lucide-react';
import clsx from 'clsx';

import { Button } from './button';

type DrawerProps = {
  title?: string;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
};
export function BasicDrawer({ title, open, onClose, children, size = 'lg' }: DrawerProps) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-[60]">
      <div className="fixed inset-0" />
      <div className="fixed inset-0 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel
              transition
              className={clsx(
                'pointer-events-auto w-screen max-w-2xl transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700',
                {
                  'max-w-md': size === 'sm',
                  'max-w-xl': size === 'md',
                  'max-w-2xl': size === 'lg',
                }
              )}
            >
              <div className="flex h-full flex-col overflow-y-auto bg-card py-6 shadow-xl">
                <div className="px-4 sm:px-6">
                  <div className="flex items-end justify-between">
                    <DialogTitle className="text-base font-semibold leading-6 text-gray-900">
                      {title}
                    </DialogTitle>
                    <div className="ml-3 flex h-7 items-center">
                      <Button onClick={onClose} size="icon" variant="ghost" className="relative">
                        <span className="absolute -inset-2.5" />
                        <span className="sr-only">Close panel</span>
                        <XIcon className="h-5 w-5" />
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="relative mt-6 flex-1 px-4 sm:px-6">{children}</div>
              </div>
            </DialogPanel>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
